
import { toTitleCase } from './stringHelpers';

export function getFirstName(username?: string) {
  if (!username) return '';
  return toTitleCase(username.split(' ')[0]);
}
